import type { SystemSurfaceId } from "../contracts/system-surface";

/** Maps only intentional deep links; all arcade and game URLs stay untouched. */
export function systemSurfaceForPath(pathname: string): SystemSurfaceId | null {
  return pathname === "/create" ? "create" : null;
}
